import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { Controller } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const BootstrapInput = styled(InputBase)(() => ({
  '& .MuiInputBase-input': {
    position: 'relative',
    border: '1px solid #E0E0E0',
    '&:focus': {
      borderColor: 'none',
    },
  },
}));

const DefaultChevronIcon = props => (
  <img
    {...props}
    style={{ margin: '-4px 12px 0px 12px', cursor: 'pointer' }}
    src="/images/icons/chevron-down.svg"
    alt="chevron-down"
  />
);

/**
 * 다중 선택 드롭다운 (react-hook-form). 값은 option.value 배열.
 * 선택 순서가 유지된다 — 첫 번째 선택이 대표 표기(백엔드 TRAINER_ID 호환 필드)로 쓰인다.
 */
export const FormInputMultiDropdown = ({
  name = 'name',
  control = {},
  sx,
  options,
  rules,
  disabled,
  placeholder,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const labelOf = optionValue => {
    const option = options?.find(opt => opt.value === optionValue);
    return option ? t(option.label) : '';
  };

  return (
    <FormControl variant="standard" sx={sx} size={'small'}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const selected = Array.isArray(value) ? value : [];
          const handleChange = e => {
            // MUI multiple은 클릭 순서대로 배열을 넘긴다 — 그대로 보존
            onChange(e.target.value);
          };

          return (
            <Select
              multiple
              error={!!error}
              displayEmpty
              sx={{
                textAlign: 'start',
                height: '50%',
                '&&.Mui-error': {
                  '.MuiInputBase-input': {
                    borderColor: theme.palette.error.main,
                  },
                },
              }}
              onChange={handleChange}
              value={selected}
              disabled={disabled}
              input={<BootstrapInput />}
              IconComponent={DefaultChevronIcon}
              renderValue={values => {
                if (!values || values.length === 0) {
                  return (
                    <span style={{ color: '#a6a6a6' }}>
                      {t(placeholder || '선택해주세요')}
                    </span>
                  );
                }
                return values.map(labelOf).filter(Boolean).join(', ');
              }}>
              {options
                ?.filter(option => option.value !== '' && option.value != null)
                .map(option => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '12px',
                      fontSize: '14px',
                    }}>
                    {/* 이름은 왼쪽, 체크 표시는 오른쪽 끝 — 행 전체가 클릭(토글) 영역 */}
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {t(option.label)}
                    </span>
                    <img
                      src={selected.includes(option.value)
                        ? '/images/icons/checked.svg'
                        : '/images/icons/unchecked.svg'}
                      alt=""
                      style={{ width: '18px', height: '18px', flexShrink: 0 }}
                    />
                  </MenuItem>
                ))}
            </Select>
          );
        }}
      />
    </FormControl>
  );
};
